import useApi from "./useApi";

export default function useForgotPassword() {
  const { post } = useApi();
  // This returns a mutation for /forgot-password
  return post("/forgot-password");
} 